import React, { useState } from 'react';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  details = null,
  showOptions = false,
  options = [],
  loading = false 
}) => {
  const [selectedOption, setSelectedOption] = useState(options[0]?.value || '');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (showOptions) {
      onConfirm(selectedOption);
    } else {
      onConfirm();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
          </div>
          
          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
            <p className="text-sm text-gray-500 mb-4">{message}</p>
            
            {details && (
              <div className="bg-gray-50 rounded-lg p-4 mb-4 text-left">
                <h4 className="font-medium text-gray-900 mb-2">Éléments qui seront supprimés :</h4>
                <div className="space-y-2 text-sm text-gray-600">
                  {details.courses > 0 && <p>• {details.courses} cours</p>}
                  {details.classes > 0 && <p>• {details.classes} classes</p>}
                  {details.teachers > 0 && <p>• {details.teachers} enseignants</p>}
                  {details.tracks > 0 && <p>• {details.tracks} filières</p>}
                  {details.sessions > 0 && <p>• {details.sessions} séances</p>}
                </div>
              </div>
            )}
            
            {showOptions && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Que faire avec les séances ?
                </label>
                <select
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                >
                  {options.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          
          <div className="flex gap-3 mt-6">
            <button
              onClick={onClose}
              disabled={loading}
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50"
            >
              Annuler
            </button>
            <button
              onClick={handleConfirm}
              disabled={loading}
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 flex items-center justify-center"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              ) : (
                'Supprimer'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;